import {Panel} from "../../bananaframework/src/controls/Panel.js"
import {Image} from "../../bananaframework/src/controls/Image.js"
import {DataGridTileItemRender} from "../../bananaframework/src/controls/listcontrols/datagrids/listrenders/DataGridTileItemRender.js"

import {Router} from "../../util/router.js";
import {ImagePlaceHolder} from "../imageplaceholder.js";

export class PlayerMarketValueItemRender extends DataGridTileItemRender{

    init (data)
    {
        super.init();
        this.data = data;
        this.panel = new Panel();
        this.panel.addCssClass("MatchStatsContainer playerMarketValueCard");
        //
        this.card = new Panel();
        this.card.addCssClass("MatchStatsContainerCard playerMarketValueCardInner");
        this.panel.addControl(this.card);
        //
        this.content = new Panel();
        this.content.addCssClass("flexHorizontalAlign playerMarketValueContent");

        this.card.addControl(this.content);

        this.rank = new Panel();
        this.rank.addCssClass("playerMarketValueRank");
        this.content.addControl(this.rank);

        this.playerImage = new ImagePlaceHolder();
        this.playerImage.addCssClass("playerMarketValueImage");
        this.content.addControl(this.playerImage);

        this.playerCountryImage = new Image();
        this.playerCountryImage.addCssClass("playerMarketValueCountryImage");
        this.content.addControl(this.playerCountryImage);

        this.playerName = new Panel();
        this.playerName.addCssClass("playerMarketValueName");
        this.content.addControl(this.playerName);

        this.playerValue = new Panel();
        this.playerValue.addCssClass("playerMarketValuePrice");
        this.content.addControl(this.playerValue);

        this.addControl(this.panel);
        this.valueFormatter = Intl.NumberFormat('en-EN', { style: 'currency', currency: 'EUR' })

        this.content.bind("click",()=>{

            Router.showPlayerScreen(this.data.id);

        });
    }

    setData (data){

        this.data = data;
        this.rank.clear();
        this.playerName.clear();
        this.playerValue.clear();

        this.rank.addControl(data.rank+"",true);

        if (this.data.style.selected){
            this.card.addCssClass("highlightanimated")
        }

        if (AppInstance.getConfig().enabledFeatures.playerImages) {
            this.playerImage.setImage(AppInstance.getConfig().url.imageBaseUrl + "/footapi/" + AppInstance.getConfig().url.teamPlayerImageUrl + "/playerimages/" + data.id + "_small_rnd.png", 40, 40);
            this.playerCountryImage.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/flags/"+data.nationality.replace(/\s|\'/g, '-').toLowerCase()+".png");
        }
        else{
            this.playerImage.addCssClass("playerMarketValueImageOffset");
            this.playerImage.setImage(AppInstance.getConfig().url.imageBaseUrl+"/footapi/images/flags/"+data.nationality.replace(/\s|\'/g, '-').toLowerCase()+".png",72,72);
            this.playerCountryImage.setVisible(false);
        }
        this.playerName.addControl(data.name+ " <br> <b><i> "+data.team+"</i></b>",true);
        this.playerValue.addControl(this.valueFormatter.format(data.marketvalue),true);
    }
};
